import {
    ActionableContainer,
    Badge,
    ButtonSkeleton,
    Skeleton,
    TextSkeleton,
} from '@gitbook/spine-react';

import type { AdaptiveContentTargetObjectType } from '../types';

export function AdaptiveContentExpressionBuilderSkeleton() {
    const target = 'page';
    return (
        <>
            <div className="flex flex-col">
                <div className="flex flex-1">
                    <div className="flex flex-1 flex-col">
                        <ActionableContainer className="flex-1 px-10 py-6">
                            <div className="text-ui-heading-medium">
                                <TextSkeleton>
                                    Only show this {getTextForTarget(target)} if:
                                </TextSkeleton>
                            </div>
                            <div>
                                <TextSkeleton>
                                    Define who can access this section by writing an expression
                                </TextSkeleton>
                                <TextSkeleton>
                                    or picking from one of the templates. To use different
                                </TextSkeleton>
                                <TextSkeleton>properties, edit your visitor schema.</TextSkeleton>
                            </div>
                            <TextSkeleton>
                                visitor.claims.isBetaUser === true && visitor.claims.isPublic
                            </TextSkeleton>
                        </ActionableContainer>
                        <AdaptiveContentExpressionTestingSectionSkeleton target={target} />
                    </div>
                    <AdaptiveContentExpressionTemplateSectionSkeleton />
                </div>
            </div>
        </>
    );
}

export function AdaptiveContentExpressionTemplateSectionSkeleton() {
    return (
        <ActionableContainer className="flex-1 bg-side px-10 py-6">
            <div className="text-ui-heading-small">
                <TextSkeleton>Templates</TextSkeleton>
            </div>
            <Skeleton shape="rect" className="h-[404px] w-[460px]">
                Templates
            </Skeleton>
        </ActionableContainer>
    );
}

export function AdaptiveContentExpressionTestingSectionSkeleton(props: {
    target: AdaptiveContentTargetObjectType;
}) {
    const { target } = props;
    return (
        <div className="flex flex-col border-t">
            <div className="flex flex-col gap-3 px-4 py-3">
                <div className="flex items-center">
                    <ButtonSkeleton size="small" label="Unauthenticated" />
                </div>
                <div className="flex items-center gap-3">
                    <Badge label="TRUE" className="shimmer text-transparent" aria-hidden />
                    <TextSkeleton>
                        This {getTextForTarget(target)} would be accessible to this test user.
                    </TextSkeleton>
                </div>
            </div>
        </div>
    );
}

export function AdaptiveContentExpressionBuilderReadOnlySkeleton() {
    return (
        <div className="flex flex-col gap-4">
            <TextSkeleton>
                This expression defines who can access this page. You can edit it in a change
                request.
            </TextSkeleton>
            <div className="text-ui-heading-medium">
                <TextSkeleton>Only show this page if:</TextSkeleton>
            </div>
            <TextSkeleton>visitor.claims.isBetaUser === true</TextSkeleton>
        </div>
    );
}

export function getTextForTarget(target: AdaptiveContentTargetObjectType) {
    switch (target) {
        case 'section-group':
            return 'section group';
        case 'header-link':
            return 'header item';
        case 'external-link':
            return 'external link';
        default:
            return target;
    }
}
